/**
 * データ管理用クラス
 */
class DataManager {
  // ---------------------------------------------------------------------------------------------------------
  // --	VARS
  // ---------------------------------------------------------------------------------------------------------

  //シングルトンインスタンス
  private static _instance: DataManager

  //データ保存用のコレクション
  private map: Map<string, any> = new Map()

  // ---------------------------------------------------------------------------------------------------------
  // --	DataManager
  // ---------------------------------------------------------------------------------------------------------

  /**
   * コンストラクタ
   */
  private constructor() {
    this.map = new Map()
  }

  /** インスタンスの取得 */
  public static get instance(): DataManager {
    if (!this._instance) {
      this._instance = new DataManager()
    }

    // 生成済みのインスタンスを返す
    return this._instance
  }

  // ---------------------------------------------------------------------------------------------------------
  // --	METHOD
  // ---------------------------------------------------------------------------------------------------------

  setData(key: string, val: any) {
    this.map.set(key, val)
  }

  getData(key: string) {
    return this.map.get(key)
  }

  deleteData(key) {
    this.map.delete(key)
  }

  clear() {
    this.map.clear()
  }

  // ---------------------------------------------------------------------------------------------------------
}

export default DataManager
